import React, { useEffect } from "react";
import {
  StyledDialog,
  StyledDialogBody,
  StyledDialogHeader,
  StyledDialogTitle,
  StyledDialogBackdrop,
} from "./styled";
import { MdCancel } from "react-icons/md";

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
}

const Dialog: React.FC<Props> = ({ open, onClose, title, children }) => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  if (!open) return null;

  return (
    <StyledDialogBackdrop>
      <StyledDialog>
        <StyledDialogHeader>
          {title && <StyledDialogTitle>{title}</StyledDialogTitle>}

          <MdCancel
            onClick={() => {
              document.body.style.overflow = "auto";
              onClose();
            }}
          />
        </StyledDialogHeader>
        <StyledDialogBody>{children}</StyledDialogBody>
      </StyledDialog>
    </StyledDialogBackdrop>
  );
};

export default Dialog;
